import { Edit } from "lucide-react"


const PrefrenceCard = ({ prefrence, onEdit }) => {

  return (
    <div className="rounded-md ">
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-lg font-medium text-[#572575] font-siromi">Preference Details</h3>
        <button
          onClick={() => onEdit(prefrence)}
          className="flex items-center text-[#DF252A] font-bold"
        >
          <Edit className="h-5 w-5 mr-1" /> Edit
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 border-b pb-4 font-altisunisa mb-6">
       <div className="">
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Broad Level:</span>
                <p className="text-black">{prefrence.broad_field_name}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Narrow Level:</span>
                <p className="text-black">{prefrence.narrow_field_name}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Education Level:</span>
                <p className="text-black">{prefrence.educational_level}</p>
              </div>
            </div>
            <div className="">
             <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Intake:</span>
                <p className="text-black">{prefrence.intake_month}   {prefrence.intake_year}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Target Country:</span>
                <p className="text-black">{prefrence.target_country_name}</p>
              </div>
            </div>
      </div>
    </div>
  )
}

export default PrefrenceCard
